import { render, staticRenderFns } from "./CartBoxItem.vue?vue&type=template&id=24d17bb6&scoped=true&"
import script from "./CartBoxItem.vue?vue&type=script&lang=js&"
export * from "./CartBoxItem.vue?vue&type=script&lang=js&"
import style0 from "./CartBoxItem.vue?vue&type=style&index=0&id=24d17bb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d17bb6",
  null
  
)

export default component.exports